export default {
  colorBody: '#efefef',
  colorButton: '#076699',
  colorDanger: '#ce0000',
  colorDisabled: '#e0e0e0',
  colorPrimary: '#41bfee',
  colorSecondary: '#344a58',
  colorSuccess: '#22c65b',
  colorWhite: '#ffffff',
  fontBase: '16px',
  radiusLarge: '50%',
  radiusMedium: '12px',
  radiusSmall: '4px',
  shadowLarge: '0 3px 3px 3px rgba(0, 0, 0, 0.6)',
  shadowMedium: '0px 1px 8px rgba(0, 0, 0, 0.2)',
  shadowSmall: '0px 0px 5px rgba(0, 0, 0, 0.15)',
};
